export const UK_TAX_RATE = 0.2
export const DE_TAX_RATE = 0.19
export const AU_TAX_RATE = 0.1
